export default "/_next/static/cbbd1797e82ba57779679e080eb3c42a.png";